import { IApiInternet, IInternet, IProduct } from "../../fetchOrderProducts";

export function isInternet(product: IProduct): product is IApiInternet {
  return "specificationId" in product && product.specificationId === "INTERNET";
}

export function mapInternetResponse(
  product: IApiInternet | undefined,
): IInternet | undefined {
  if (product === undefined) {
    return;
  }

  const serviceOptionStr = product.characteristic?.serviceOption;
  if (!serviceOptionStr) {
    return undefined;
  }

  const [downloadSpeed, uploadSpeed] = serviceOptionStr
    .replace(/m/gi, "")
    .split("/")
    .map(Number);

  return {
    ...product,
    downloadSpeed,
    uploadSpeed,
  };
}
